import { useContext, useEffect, useState } from "react"
import Loader from "./Loader"
import PageContext from "../global_state/context/PageContext";
import LogOutUser from "services/LogOutUser";
import { PageType, PopUpType } from "types/PageI";
import { getUser } from "services/user_services/GetUser";

import headerPlaceholder from '../assets/img/header.jpg' 

import SCSS from '../assets/scss/UserHeader.module.scss'
import AppSCSS from '../assets/scss/App.module.scss'

import content from 'languages/UserHeader.json'
import { format_price_number } from "services/functions";
import UserContext from "global_state/context/UserContext";

function UserHeader() {
    
    const {user, dispatchUser} = useContext(UserContext)
    const {page, dispatchPage} = useContext(PageContext)
    let lang = page.settings.language
    
    const [log_out_response, setLogOutResponse] = useState<string | any[]>()    
    const [get_user_response, setGetUserResponse] = useState<any>()
    // const [custom_credit_value, setCustomCreditValue] = useState<number>(200)

    const handleLogOut = async (e) => {
        
        e.preventDefault()
        dispatchPage({
            type: "set_popup",
            payload: {
                popup: null,
            }
        })
        dispatchPage({
            type: "remove_all_notification"
        })
        
        setLogOutResponse( await LogOutUser(user.client_id, user.connection_id))
    }

    const handleBuyCreditPopup = (e) => {
        e.preventDefault()
        dispatchPage({
            type: "set_popup",
            payload: {
                popup: PopUpType.buy_credits,
                props: {
                }
            }
        })
    }

    useEffect(() => {
        const getUserResponse = async () => {
            setGetUserResponse( await getUser())
        }
        getUserResponse()
    }, [])

    useEffect(() => {
        
        if (get_user_response == undefined || typeof get_user_response == 'string') {
            return 
        }
        
        dispatchUser({type: "update_user", payload: get_user_response})
    }, [get_user_response])

    useEffect(() => {
        if (!log_out_response) {
            return 
        }
        dispatchUser({type: "log_out", payload: log_out_response})       
        dispatchPage({type: "log_out", payload: PageType.entrance})       

    }, [log_out_response, dispatchPage, dispatchUser])


    if (user.first_name === null) {
        return (
            <Loader/>
        )
    }

    return(
        <>
        <div className={SCSS.user_header}>
            <div className={SCSS.header_placeholder}>
                <img src={headerPlaceholder} alt="" />
            </div>

            <div className={SCSS.user_stats}>
                <div className={SCSS.row}>
                    <span className={SCSS.user_stats_title}>{content[lang].logged}:</span>
                    <span className={SCSS.user_stats_value}>{user.email}</span>
                    
                </div>
                <div className={SCSS.row}>
                    <span className={SCSS.user_stats_title}>{content[lang].balance}:</span>
                    <span className={SCSS.user_stats_value}>{format_price_number(user.credits)},- Kč</span>
                </div>
            </div>
            <div className={SCSS.buttons}>
                <button 
                    onClick={(e) => {handleBuyCreditPopup(e)}}
                    className={[AppSCSS.button, AppSCSS.red].join(" ")} type="button">
                    {content[lang].add_credit}
                </button>

                <button 
                    onClick={(e) => {handleLogOut(e)}}
                    // onClick={(e) => {handleSwitchPage(e)}}
                    className={[AppSCSS.button, AppSCSS.red].join(" ")} type="button">
                    {/* {content[language].eshop} */}
                    {content[lang].log_out}
                </button>
            </div>
            
           

        </div>
        
        {/* {renderBuyCreditPopUp()} */}

        
        </>
    )
}
export default UserHeader

